import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const CanonicalTag = () => {
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://www.plootus.com';

  const canonicalUrl = baseUrl + location.pathname.replace(/\/$/, "");

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;